(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["n-proof"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('n-proof')) {
  class NorelviProof extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-proof-track]');
      if (!this.track) return;
      this.cleanup?.abort();
      this.cleanup = new AbortController();
      const options = { signal: this.cleanup.signal };
      this.controls = this.querySelector('[data-proof-controls]');
      this.previous = this.querySelector('[data-proof-previous]');
      this.next = this.querySelector('[data-proof-next]');
      this.dots = this.querySelector('[data-proof-dots]');
      if (!this.controls || !this.previous || !this.next || !this.dots) return;
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), options);
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.cleanup?.abort(); this.resize?.disconnect(); }
    move(direction) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    }
    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      this.controls.hidden = maximum <= 2;
      this.previous.disabled = this.track.scrollLeft < 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
      const pages = this.track.clientWidth > 0 ? Math.max(1, Math.ceil(this.track.scrollWidth / this.track.clientWidth)) : 1;
      const current = maximum > 2 ? Math.round(this.track.scrollLeft / maximum * (pages - 1)) : 0;
      if (this.dots.children.length !== pages) {
        this.dots.replaceChildren();
        for (let index = 0; index < pages; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button'; dot.className = 'n-proof__dot';
          dot.setAttribute('aria-label', `${this.dots.getAttribute('aria-label')} ${index + 1}`);
          dot.addEventListener('click', () => {
            const max = this.track.scrollWidth - this.track.clientWidth;
            this.track.scrollTo({ left: pages === 1 ? 0 : max * index / (pages - 1), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          }, { signal: this.cleanup.signal });
          this.dots.append(dot);
        }
      }
      for (const [index, dot] of Array.from(this.dots.children).entries()) dot.setAttribute('aria-current', index === current ? 'true' : 'false');
    }
  }
  customElements.define('n-proof', NorelviProof);
}

  } catch(e) { console.error(e); }
})();
})();
